import React from "react";
import { Link } from "react-router-dom";

const quickLinks = [
    ["Services", "/#services"],
    ["How it works", "/#how"],
    ["Results", "/#gallery"],
    ["About", "/#about"],
    ["Service area", "/#area"],
    ["Get a quote", "/#contact"],
];

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="relative bg-[var(--ink)] text-[var(--paper)] pt-20 md:pt-28 pb-10 grain"
        >
            <div className="maxw section-pad relative z-10">
                <div className="grid md:grid-cols-12 gap-12">
                    <div className="md:col-span-5">
                        <Link
                            to="/"
                            className="flex items-center gap-3 mb-6"
                            data-testid="footer-brand"
                        >
                            <span className="relative w-12 h-12 rounded-[12px] bg-[var(--paper)] flex items-center justify-center overflow-hidden ring-1 ring-white/10">
                                <img
                                    src="/logo-mark.png"
                                    alt="FreshEdge Services"
                                    className="w-[88%] h-[88%] object-contain"
                                    width="48"
                                    height="48"
                                    loading="lazy"
                                    decoding="async"
                                />
                            </span>
                            <span className="font-display text-[20px] tracking-tight">
                                FreshEdge Services
                            </span>
                        </Link>
                        <p className="font-display text-2xl md:text-[28px] leading-[1.18] tracking-tight max-w-md">
                            Lawn, garden, cleanup, pressure washing, returfing
                            and outdoor property maintenance.
                        </p>
                        <a
                            href="#contact"
                            className="mt-8 inline-flex items-center gap-2 btn-paper"
                            data-testid="footer-cta"
                        >
                            Get a Free Quote
                            <span>→</span>
                        </a>
                    </div>

                    <div className="md:col-span-4">
                        <div className="eyebrow-light mb-5">Contact</div>
                        <ul className="flex flex-col gap-4 text-[14px]">
                            <li className="flex items-baseline justify-between gap-4 border-b border-line-dark pb-3">
                                <span className="font-mono-x text-[11px] text-[rgba(242,237,227,0.6)]">
                                    Phone
                                </span>
                                <a
                                    href="tel:0435995971"
                                    className="hover:text-[var(--terra-soft)] transition"
                                    data-testid="footer-phone"
                                >
                                    0435 995 971
                                </a>
                            </li>
                            <li className="flex items-baseline justify-between gap-4 border-b border-line-dark pb-3">
                                <span className="font-mono-x text-[11px] text-[rgba(242,237,227,0.6)]">
                                    Email
                                </span>
                                <a
                                    href="mailto:Thefreshedgeservice@gmail.com"
                                    className="hover:text-[var(--terra-soft)] transition break-all text-right"
                                    data-testid="footer-email"
                                >
                                    Thefreshedgeservice@gmail.com
                                </a>
                            </li>
                            <li className="flex items-baseline justify-between gap-4 border-b border-line-dark pb-3">
                                <span className="font-mono-x text-[11px] text-[rgba(242,237,227,0.6)]">
                                    Service area
                                </span>
                                <span className="text-right">
                                    Queanbeyan · Canberra · Tuggeranong &amp;
                                    surrounding areas
                                </span>
                            </li>
                            <li className="flex items-baseline justify-between gap-4">
                                <span className="font-mono-x text-[11px] text-[rgba(242,237,227,0.6)]">
                                    Hours
                                </span>
                                <span className="text-right">
                                    Weekdays 3:15pm — 7pm
                                    <br className="hidden sm:inline" />
                                    <span className="hidden sm:inline">·{" "}</span>
                                    Weekends 7:30am — 7:30pm
                                </span>
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <div className="eyebrow-light mb-5">Quick links</div>
                        <ul className="flex flex-col gap-3 text-[14px]">
                            {quickLinks.map(([l, h]) => (
                                <li key={h}>
                                    <a
                                        href={h}
                                        className="hover:text-[var(--terra-soft)] transition"
                                    >
                                        {l}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="mt-20 hr-line-dark" />

                <div className="mt-6 flex flex-wrap items-center justify-between gap-4 font-mono-x text-[11px] text-[rgba(242,237,227,0.6)]">
                    <div>
                        © FreshEdge Services · Run by two hardworking teens ·
                        Public liability insured.
                    </div>
                    <div className="flex items-center gap-6">
                        <Link to="/services" className="hover:text-[var(--terra-soft)]">
                            /services
                        </Link>
                        <Link to="/about" className="hover:text-[var(--terra-soft)]">
                            /about
                        </Link>
                        <Link to="/contact" className="hover:text-[var(--terra-soft)]">
                            /contact
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
